import { render, staticRenderFns } from "./index--command.vue?vue&type=template&id=4fecc988&scoped=true&"
import script from "./index--command.vue?vue&type=script&lang=js&"
export * from "./index--command.vue?vue&type=script&lang=js&"
import style0 from "./index--command.vue?vue&type=style&index=0&id=4fecc988&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fecc988",
  null
  
)

export default component.exports